import { Component, Input } from '@angular/core';
import { defaultDisplayAttributes } from '../../../../core/models/default-display-attributes.const';
import { IFilterData } from '../../../../core/models/filter-data.model';
import { IProduct } from '../../../../core/models/product.model';
import { IDisplayMetric } from '../../../../core/models/display-metric.model';

@Component({
    selector: 'lynkd-pattern-gallery-listing-caption',
    templateUrl: './gallery-listing-caption.component.html',
    styleUrls: ['./gallery-listing-caption.component.scss']
})
export class GalleryListingCaptionComponent {
    @Input()
    public filterData: IFilterData = {
        display_attributes: defaultDisplayAttributes
    };

    @Input()
    public metricStyle: Record<string, string>;

    @Input()
    public product: IProduct;

    public getGallerySortedDisplayMetrics(): Array<IDisplayMetric> {
        return this.filterData?.display_metrics?.sort((a: IDisplayMetric, b: IDisplayMetric) => {
                    // Sort gallery metrics by their rank
                    if (a.isDefaultGalleryMetric && b.isDefaultGalleryMetric) {
                        return a.galleryRank - b.galleryRank;
                    }
                    if (a.isDefaultGalleryMetric) return -1;
                    if (b.isDefaultGalleryMetric) return 1;

                    // Everything else maintains original order
                    return 0;
                });
    }
}
